// MIT License - Copyright (c) 2026 Doug McNall - See .kiro/steering/general/development-standards.md for full license

/**
 * Doctor Who Universe - Warp Gates Configuration
 */

export const warpGates = [
  {
    id: 'gate-doctorwho-masseffect',
    name: 'Temporal Mass Relay',
    type: 'warpgate',
    distance: 22,
    fromUniverse: 'doctorwho',
    destinationUniverse: 'masseffect',
    fromSystem: 1000,
    toSystem: 900,
    destinationGate: 'gate-masseffect-doctorwho',
    energyCost: 50,
    fuelRequired: 5,
    threat: 'TEMPORAL',
    resources: 'GATEWAY',
    services: [],
    primaryColor: '#003B6F',
    secondaryColor: '#00d4ff',
    hasRings: true,
    discovered: false,
    description: 'Time vortex intersects with mass relay technology. Prothean and Time Lord engineering converge. Wibbly-wobbly eezo fields.',
    scanDescription: 'ANALYSIS: Temporal gateway to Mass Effect universe detected. Time vortex + mass relay hybrid. Destination: The Citadel. Gate travel does not consume fuel.'
  }
];

export const warpGatePositions = {
  'gate-doctorwho-masseffect': { x: 40, y: 60, z: -4 }
};

const doctorwhoGates = { warpGates, warpGatePositions };
export default doctorwhoGates;
